import { SkyscannerRankexplainabilityV1 } from '@skyscanner-internal/rank-explainability-web-http-client';

import { grpcFetchClientWrapper } from '../internals/clients/grpc/grpc';

const RANK_EXPLAINABILITY_CLIENT_NAME = 'RANK_EXPLAINABILITY';

export const rankExplainabilityRequest = grpcFetchClientWrapper(
  SkyscannerRankexplainabilityV1.RankExplainabilityService.GetRankExplainabilityMessage,
  {
    clientName: RANK_EXPLAINABILITY_CLIENT_NAME,
    pathPrefix: '/g/rank-explainability',
  },
);
